import { render, staticRenderFns } from "./InvitationAccept.vue?vue&type=template&id=61e3c24c&scoped=true&"
import script from "./InvitationAccept.vue?vue&type=script&lang=ts&"
export * from "./InvitationAccept.vue?vue&type=script&lang=ts&"
import style0 from "./InvitationAccept.vue?vue&type=style&index=0&id=61e3c24c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e3c24c",
  null
  
)

export default component.exports